import React from 'react';
import { Box, Button, ButtonColor } from '@alirosoftware/web-components';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import { useGetMeQuery } from '../../../graphql/_generated';
import { userSignupLoginRedirectLocation } from '../../../utils/user';

export const PasswordReset = () => {
  const { data } = useGetMeQuery({ fetchPolicy: 'cache-first' });
  const { t } = useTranslation();
  return (
    <Box className="card card-vertical">
      <h1 className="u-mb-4 u-mt-4">{t('forgotPasswordReset')}</h1>
      <p>{t('forgotPasswordResetDesc')}</p>
      {data?.me ? (
        <Box className="card-actions">
          <Link href={userSignupLoginRedirectLocation(data.me)}>
            <Button color={ButtonColor.Primary} testId="continue">
              {t('continue')}
            </Button>
          </Link>
        </Box>
      ) : null}
    </Box>
  );
};
